import gql from "graphql-tag";

export const FOUNDING_PROCESS_CONFIG = gql`
  query FoundingProcessConfig {
    foundingProcessConfig {
      config
    }
  }
`;
